import { templatesArraySchema } from '@src/components/Home/Config-Beta/Modes/validation/templateSchema';
import { UseTemplateValidationResult } from '@src/types/hooks';
import { getValidationTypeGuards } from '@src/utils/validationTypeGuards';
import useFileValidation from './useFileValidation';

export default function useTemplateValidation(): UseTemplateValidationResult {
  const {
    createStringPropertyTypeGuard,
    createArrayPropertyTypeGuard,
    isObjectWithProperty,
  } = getValidationTypeGuards();

  // Create specific type guards
  const isTemplateWithName = createStringPropertyTypeGuard('name');
  const isSettingWithLabel = createStringPropertyTypeGuard('uiLabel');
  const isFieldWithLabel = createStringPropertyTypeGuard('uiLabel');
  const isObjectWithSettings = createArrayPropertyTypeGuard('settings');
  const isObjectWithFields = createArrayPropertyTypeGuard('fields');

  return useFileValidation({
    schema: templatesArraySchema,
    entityName: 'Template',
    arrayProcessors: {
      '': (currentObject, index) => {
        if (Array.isArray(currentObject)) {
          return {
            humanPart: isTemplateWithName(currentObject[index])
              ? `Template "${currentObject[index].name}"`
              : `Template [${index}]`,
            nextObject: currentObject[index] as
              | Record<string, unknown>
              | undefined,
          };
        }
        return {
          humanPart: `Template [${index}]`,
          nextObject: undefined,
        };
      },
      settings: (currentObject, index) => {
        if (isObjectWithSettings(currentObject)) {
          const item = currentObject.settings[index];
          return {
            humanPart: isSettingWithLabel(item)
              ? `Setting "${item.uiLabel}"`
              : `Setting [${index}]`,
            nextObject: item as Record<string, unknown> | undefined,
          };
        }
        return {
          humanPart: `settings[${index}]`,
          nextObject: undefined,
        };
      },
      fields: (currentObject, index) => {
        if (isObjectWithFields(currentObject)) {
          const item = currentObject.fields[index];
          return {
            humanPart: isFieldWithLabel(item)
              ? `Field "${item.uiLabel}"`
              : `Field [${index}]`,
            nextObject: item as Record<string, unknown> | undefined,
          };
        }
        return {
          humanPart: `fields[${index}]`,
          nextObject: undefined,
        };
      },
    },
    typeGuards: {
      createStringPropertyTypeGuard,
      createArrayPropertyTypeGuard,
      isObjectWithProperty,
    },
  });
}
